import { useGlobalFileUpload } from './useGlobalFileUpload'

/**
 * Simple adapter that provides access to existing upload/download functionality
 * No state management - just delegates to existing stores
 */
export const useProgressTrackerAdapter = () => {
  const uploadStore = useGlobalFileUpload()

  // Return existing functions directly
  return {
    // Add files (delegate to existing upload store)
    addFiles: uploadStore.addFiles,
  }
}
